import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { EpisodeTreatmentProgram } from '~/lib/constants/patients.constants';
import { useGetTreatmentProgramsEnumQuery } from '~/store/services/enumerations';

interface UseTreatmentProgramsResult {
  allPrograms: EpisodeTreatmentProgram[];
  isLoading: boolean;
  newEpisodePrograms: EpisodeTreatmentProgram[];
}

export const useTreatmentPrograms = (
  excludedOverride?: EpisodeTreatmentProgram[],
): UseTreatmentProgramsResult => {
  const { enableBridgeProgram: isTransitionTrackEnabled } = useFlags<LDFlags>();

  const computedExcluded = useMemo<EpisodeTreatmentProgram[]>(() => {
    return isTransitionTrackEnabled ? [] : [EpisodeTreatmentProgram.TRANSITION];
  }, [isTransitionTrackEnabled]);

  const excludedPrograms = excludedOverride ?? computedExcluded;

  const { data: allPrograms = [], isLoading } =
    useGetTreatmentProgramsEnumQuery(excludedPrograms);

  const newEpisodePrograms = useMemo<EpisodeTreatmentProgram[]>(() => {
    if (!allPrograms.length) return [];
    return allPrograms.filter(
      (p) => p !== EpisodeTreatmentProgram.RELAPSE_PREVENTION,
    );
  }, [allPrograms]);

  return {
    allPrograms,
    isLoading,
    newEpisodePrograms,
  };
};
